const types = {
    SET_PERSONAL_BONUSES: '[PERSONAL] SET PERSONAL BONUSES',
    SET_HISTORY_BONUSES: '[PERSONAL] SET HISTORY BONUSES',
}

export {
    types,
}